export default __webpack_public_path__ + "static/media/courseBg1.80011fae.png";